<template>
  <div class="field">
    <input
      type="color"
      name="color"
      class="field__input color-picker"
      :value="defaultColor"
      @input="$emit('input', $event.target.value)"
      @change="logColor"
    />
    <label for="color" class="field__label">Korostus väri</label>
  </div>
</template>

<script>
export default {
  name: "ColorPicker",
  props: {
    defaultColor: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      color: null
    }
  },
  methods: {
    logColor(){
      console.log(this.color);
    }
  }
}
</script>
<style lang="scss" scoped>
.color-picker {
  padding: 0;
  width: 2em;
  height: 2em;
  margin-top: 1rem;
  border-radius: 50%;
}
input[type="color"] {
	-webkit-appearance: none;
	border: none;
  border-radius: 50%;
}
input[type="color"]::-webkit-color-swatch-wrapper {
  border-radius: 50%;
	padding: 0;
}
input[type="color"]::-webkit-color-swatch {
  border-radius: 50%;
	border: none;
}
</style>